import React from 'react';
import classNames from 'classnames';
import { CaretDownOutlineIcon } from '@sm/question-ui/respondent-survey';
import { NativeSelect, NativeSelectProps } from '~app/components/core/NativeSelect';
import useStyles from './useStyles';

export type SelectProps = Omit<NativeSelectProps, 'icon'>;

export function Select({ className, ...props }: SelectProps): React.ReactElement {
  const { selectContainer } = useStyles();

  return <NativeSelect icon={<CaretDownOutlineIcon />} className={classNames(selectContainer, className)} {...props} />;
}

export default Select;
